import React, { useState, useContext, useEffect } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { Form, Field } from "react-final-form";
import {
  GET_USER_FAVORITE_REPORTS,
  ADD_FAVORITE_REPORT,
  DELETE_FAVORITE_REPORT
} from "../../queries/archiveQrys/secureQrys/userProfileQrys";
import SkeletonLoader from "../reuseableComponents/loaders/SkeletonLoader";
import { UserContext } from "../reuseableComponents/auth/UserContext";

const PinToFavorites = (props) => {
  const { user } = useContext(UserContext);
  const [favorites, setFavorites] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isPinned, setIsPinned] = useState(false);

  const { loading, data } = useQuery(GET_USER_FAVORITE_REPORTS, {
    variables: { umdId: user.umdId },
    onCompleted: (data) => {
      setFavorites(data.getUserFavoriteReportsByUmdId);
      setIsLoading(false);
    }
  });

  const [addNewFavoriteReportMutation, addResults] = useMutation(ADD_FAVORITE_REPORT, {
    refetchQueries: [{ query: GET_USER_FAVORITE_REPORTS, variables: { umdId: user.umdId } }],
    awaitRefetchQueries: true
  });

  const [deleteFavoriteReportMutation, deleteResults] = useMutation(DELETE_FAVORITE_REPORT, {
    refetchQueries: [{ query: GET_USER_FAVORITE_REPORTS, variables: { umdId: user.umdId } }],
    awaitRefetchQueries: true
  });

  const onSubmit = (submit, form) => {};

  const addReport = (reportId) => {
    setIsLoading(true);
    addNewFavoriteReportMutation({
      variables: {
        umdId: user.umdId,
        reportId: reportId
      }
    });
    setIsPinned(true);
  };

  const deleteReport = (reportId) => {
    setIsLoading(true);
    deleteFavoriteReportMutation({
      variables: {
        umdId: user.umdId,
        reportId: reportId
      }
    });
    setIsPinned(false);
  };

  const updateForm = (submit, form) => {
    if (!isPinned) {
      setIsPinned(true);
      addReport(props.reportId);
    } else {
      setIsPinned(false);
      deleteReport(props.reportId);
    }
  };

  useEffect(() => {
    if (data && data.getUserFavoriteReportsByUmdId !== undefined) {
      setFavorites(data.getUserFavoriteReportsByUmdId);
    }

    Array.isArray(favorites) && favorites.forEach((element) => {
      if (parseInt(element.reportId) === parseInt(props.reportId)) {
        if (!isLoading) setIsPinned(true);
      }
    });

    //The comment below MUST stay there so that react builds
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, deleteResults, addResults, favorites, props.reportId]);

  if (loading) return <SkeletonLoader width='100%' />;

  return (
    <>
      {!user.isPublic ? (
        <Form
          onSubmit={onSubmit}
          initialValues={{ isPinned: isPinned }}
          render={({ handleSubmit, form, submitting, values }) => (
            <form onSubmit={handleSubmit}>
              <Field
                id='checkedBox'
                name='isPinned'
                component='input'
                className='big-checkbox mt-0 me-3'
                type='checkbox'
                onChange={updateForm}
              />
              <label htmlFor='checkedBox' className='mt-3'>Pinned to Favorite Reports</label>
            </form>
          )}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default PinToFavorites;
